export default {
	profile: 'PROFILE',
	message: 'MESSAGE',
	contract: 'CONTRACT',
	routePath: 'ROUTEPATH',
	breadCrumb: 'BREAD_CRUMB'
};




// WEBPACK FOOTER //
// ./src/store/mutation-types.js